import React from 'react';
import { FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';

const CountryAnalytics = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-gray-400">
        <p>No country data available</p>
      </div>
    );
  }

  const totalClicks = data.reduce((sum, item) => sum + item.count, 0);
  const topCountries = data.slice(0, 10); // Show top 10 countries

  const getCountryFlag = (country) => {
    // Simple flag emoji mapping for common countries
    const flagMap = {
      'Turkey': '🇹🇷',
      'United States': '🇺🇸',
      'Germany': '🇩🇪',
      'France': '🇫🇷',
      'United Kingdom': '🇬🇧',
      'Italy': '🇮🇹',
      'Spain': '🇪🇸',
      'Netherlands': '🇳🇱',
      'Canada': '🇨🇦',
      'Australia': '🇦🇺',
      'Japan': '🇯🇵',
      'China': '🇨🇳',
      'India': '🇮🇳',
      'Brazil': '🇧🇷',
      'Russia': '🇷🇺',
      'Unknown': '🌍'
    };
    
    return flagMap[country] || '🌍';
  };

  const getCountryColor = (index) => {
    const colors = [
      'bg-blue-500',
      'bg-green-500',
      'bg-purple-500',
      'bg-yellow-500',
      'bg-red-500',
      'bg-indigo-500',
      'bg-pink-500',
      'bg-teal-500',
      'bg-orange-500',
      'bg-cyan-500'
    ];
    return colors[index % colors.length];
  };

  return (
    <div className="flex flex-col h-full">
      <div className="space-y-4 flex-grow">
        {topCountries.map((item, index) => (
        <div key={index} className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="text-2xl">{getCountryFlag(item.country)}</div>
            <div className="text-left">
              <div className="text-white font-medium">{item.country} <span className="text-sm text-gray-400">({item.count} clicks)</span></div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="text-right">
              <div className="text-white font-semibold">{item.percentage}%</div>
            </div>
            
            <div className="w-24 bg-gray-700 rounded-full h-2">
              <div 
                className={`h-2 rounded-full ${getCountryColor(index)} transition-all duration-300`}
                style={{ width: `${item.percentage}%` }}
              ></div>
            </div>
          </div>
        </div>
        ))}
        
        {/* Show "Others" if there are more than 10 countries */}
        {data.length > 10 && (
          <div className="flex items-center justify-between pt-2 border-t border-gray-700">
            <div className="flex items-center space-x-3">
              <FaGlobe className="w-5 h-5 text-gray-400" />
              <div className="text-left">
                <div className="text-white font-medium">Other Countries <span className="text-sm text-gray-400">({data.slice(10).reduce((sum, item) => sum + item.count, 0)} clicks)</span></div>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="text-right">
                <div className="text-white font-semibold">
                  {Math.round((data.slice(10).reduce((sum, item) => sum + item.count, 0) / totalClicks) * 100)}%
                </div>
              </div>
              
              <div className="w-24 bg-gray-700 rounded-full h-2">
                <div 
                  className="h-2 rounded-full bg-gray-500 transition-all duration-300"
                  style={{ 
                    width: `${Math.round((data.slice(10).reduce((sum, item) => sum + item.count, 0) / totalClicks) * 100)}%` 
                  }}
                ></div>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Summary */}
      <div className="mt-6 pt-4 border-t border-gray-700">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{totalClicks}</div>
            <div className="text-sm text-gray-400">Total Clicks</div>
          </div>
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{data.length}</div>
            <div className="text-sm text-gray-400">Different Countries</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryAnalytics;
